import styled from 'styled-components'
import { Typography } from '@chegg-ui/typography'
import { spacing } from '@chegg-ui/theme'
import { FeedbackTab } from '@chegg-wt/core-wa/constants/paraphraser'

interface BannerWrapperProperties {
  activeTab: number
}

export const Container = styled.div`
  padding: 0 ${spacing.px16};
`

export const BannerHeading = styled(Typography)`
  margin-bottom: ${spacing.px12};
`

export const BannerWrapper = styled.div<BannerWrapperProperties>`
  display: flex;
  border-radius: ${spacing.px8};
  background: ${(props) =>
    props.activeTab === FeedbackTab.GRAMMAR_TAB ? '#E7FAF6' : '#EFF8FF'};
  margin-top: ${spacing.px16};
  padding: ${spacing.px24};
`

export const BannerText = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ImageContainer = styled.div`
  display: flex;
  width: 40%;
  justify-content: space-evenly;
  align-items: center;
`

export const SuggestionsFor = styled.div`
  display: flex;
  border-radius: 13px;
  border: 1px solid #eae7e7;
  justify-content: space-evenly;
  align-items: center;
  padding: ${spacing.px8};
`

export const KeepGrowingText = styled(Typography)`
  margin: ${spacing.px24} 0 ${spacing.px12};
`
